export default __webpack_public_path__ + "static/media/1.d577bc00.png";